(function () {
  angular
    .module('kareo.ui.shared.directives.k-edit-patient.private.k-edit-billing-profile', [
      'angucomplete-alt',
      'kareo.ui.shared.directives.k-edit-patient.private.billing-profile-types',
      'kareo.ui.shared.directives.k-edit-patient.private.k-escape-html',
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.directives.k-patient-check-eligibility.directive',
      'kareo.ui.shared.directives.k-patient-check-eligibility',
      'kareo.ui.shared.directives.k-create-insurance-plan-company'
    ])
    .directive('kEditBillingProfile', kEditBillingProfile);

  function kEditBillingProfile() {
    return {
      bindToController: true,
      controller,
      controllerAs: 'vm',
      scope: {
        isOpen: '=',
        patient: '='
      },
      template: require('./k-edit-billing-profile.pug')()
    };
  }

  controller.$inject = ['BILLING_PROFILE_TYPES', '$q', '$scope'];
  function controller(BILLING_PROFILE_TYPES, $q, $scope) {
    var vm = this;

    vm.addSecondaryInsurance = addSecondaryInsurance;
    vm.cancelEditingBillingProfile = cancelEditingBillingProfile;
    vm.confirmBillingProfile = confirmBillingProfile;
    vm.primaryPlanSelected = planSelected.bind(null, 'primary');
    vm.removeSecondaryInsurance = removeSecondaryInsurance;
    vm.secondaryPlanSelected = planSelected.bind(null, 'secondary');
    vm.insurancePlanCreated = insurancePlanCreated;
    vm.inputChanged = inputChanged;

    vm.planNameInputValue = '';

    vm.params = {
      editPlan: false,
      companyPlan: {},
      insuranceCompanyId: 0,
      planNameInputValue: ''
    };

    init();

    // ----------------------------------------------------------------------

    function init() {
      vm.isBillingMethodSelfPay =
        vm.patient.insurance === BILLING_PROFILE_TYPES.SELF_PAY;

      vm.editableInsurance = typeof vm.patient.insurance === 'object' ?
                             Object.create(vm.patient.insurance) :
                             { primary: {} };
    }

    // ----------------------------------------------------------------------

    function addSecondaryInsurance() {
      vm.editableInsurance.secondary = {};
    }

    function cancelEditingBillingProfile() {
      vm.isOpen = false;
    }

    function confirmBillingProfile() {
      vm.patient.insurance = vm.isBillingMethodSelfPay ?
                             BILLING_PROFILE_TYPES.SELF_PAY :
                             vm.editableInsurance;
      vm.isOpen = false;
    }

    // "originalObject" and PascalCase properties are side effects of webapp
    // api design

    var creatingPlanType;

    function insurancePlanCreated(newPlan) {
      if (!!newPlan && !angular.equals(newPlan, {})) {
        $scope.$broadcast('angucomplete-alt:changeInput', creatingPlanType, newPlan);
      }

      vm.creatingInsurancePlan = false;
    }

    function inputChanged(str) {
      vm.planNameInputValue = str;
    }

    function planSelected(planType, selected) {
      var orig;

      if (typeof vm.editableInsurance[planType] !== 'object') {
        return;
      }

      if (!!selected) {
        orig = selected.originalObject;
        if (angular.equals(orig, {})) {
          creatingPlanType = planType;
          vm.params.planNameInputValue = vm.planNameInputValue;
          vm.creatingInsurancePlan = true; // display creation modal
        } else {
          setInsurancePlan(planType, orig);
        }
      }
    }

    function setInsurancePlan(planType, orig) {
      vm.editableInsurance[planType].planName = orig.planName;
      vm.editableInsurance[planType].planId = orig.insuranceCompanyPlanId;
    }

    function removeSecondaryInsurance() {
      vm.editableInsurance.secondary = null;
    }

    vm.fullName = function () {
      var fullName;
      if (!!vm.patient.firstName && vm.patient.firstName.length > 0) {
        fullName = vm.patient.firstName;
      }

      if (!!vm.patient.lastName && vm.patient.lastName.length > 0) {
        fullName = (!!fullName ? fullName : '') + (!!fullName ? ' ' : '') + vm.patient.lastName;
      }

      return fullName;
    };
  }
})();
